import dishDelMar from "../assets/posters/dish-del-mar-spaghetti.jpg";
import dishSweetbomb from "../assets/posters/dish-sweetbomb.jpg";
import dishNacho from "../assets/posters/dish-nacho-blust.jpg";
import dishBbq from "../assets/posters/dish-bbq-beef-lover.jpg";
import dishChickslaw from "../assets/posters/dish-chick-slaw.jpg";
import dishChickMush from "../assets/dish-chick-mush-poster.jpg";
import dishHotty from "../assets/dish-hotty-fingers.jpg";
import dishPenne from "../assets/dish-penne-beast-slayer.jpg";
import dishBombers from "../assets/dish-bombers-chili-poutine.jpg";
import dipsSpread from "../assets/dips-spread.jpg";
import drinksSpread from "../assets/drinks-spread.jpg";

export const BRAND = {
  name: "PATTISTA",
  slogan: "Best PATTIes and paSTAs in the town!",
  sloganAccent: "Love at first bite!",
  signoff: "Good Food · Good Vibes · Pattista",
  phoneDisplay: "(204) 951-3225",
  phoneHref: "tel:2049513225",
  email: "pattista01@gmail.com",
  address: "120 Lowson Cres #2, Winnipeg, MB R3P 2H8",
  deliveryPartners: ["UberEATS", "DoorDash"],
  dealsNote: "Deals & discounts for in-person pickup orders",
  priceNote:
    "Prices in the menu are for in-person orders only. Prices slightly vary on UberEATS & DoorDash.",
};

export const HOURS = [
  { day: "Tuesday", time: "5 PM – 12 AM" },
  { day: "Wednesday", time: "5 PM – 1:45 AM" },
  { day: "Thursday", time: "5 PM – 1:45 AM" },
  { day: "Friday", time: "5 PM – 1:45 AM" },
  { day: "Saturday", time: "5 PM – 1:45 AM" },
  { day: "Sunday", time: "5 PM – 1:45 AM" },
  { day: "Monday", time: "5 PM – 12 AM" },
];

export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(
  "120 Lowson Cres #2, Winnipeg, MB R3P 2H8",
)}&output=embed`;

export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  "120 Lowson Cres #2, Winnipeg, MB R3P 2H8",
)}`;

export const MENU = {
  burgers: [
    {
      name: "BBQ Beef Lover Burger",
      price: 17.0,
      desc: "A rich BBQ Angus beefy flavors with beef bacon strip.",
      comesWith: "Comes with Complimentary Fries!",
      img: dishBbq,
    },
    { name: "The Playboy Burger", price: 16.0, comesWith: "Comes with Complimentary Fries!" },
    {
      name: "Sweetbomb Burger",
      price: 14.0,
      desc: "A Sweet & Savory Explosion!",
      comesWith: "Comes with Complimentary Fries!",
      img: dishSweetbomb,
    },
    { name: "The Fatty Burger", price: 14.0, comesWith: "Comes with Complimentary Fries!" },
    { name: "Maddy Bella Burger", price: 15.0, comesWith: "Comes with Complimentary Fries!" },
    {
      name: "Chick-Slaw Burger",
      price: 13.0,
      desc: "A juicy crispy fried chicken, house made fresh coleslaw, pickles and special sauce on a toasted sesame bun.",
      comesWith: "Comes with Complimentary French Fries!",
      img: dishChickslaw,
    },
    { name: "Triple Trouble Burger", price: 15.0, comesWith: "Comes with Complimentary Fries!" },
    { name: "Sweet Bomb Solo Bite", price: 10.0, deal: true, comesWith: "Comes with Complimentary Fries!" },
    { name: "The Uno Fatty", price: 10.0, deal: true, comesWith: "Comes with Complimentary Fries!" },
  ],
  pasta: [
    {
      name: "Th Del-Mar Spaghetti Pasta",
      price: 17.0,
      desc: "House made pasta tossed with tender squid, succulent shrimp, our signature secret creamy sauce finished with secret blend of flavors for a bold savory dish.",
      comesWith: "Comes with Complimentary Garlic Bread!",
      img: dishDelMar,
    },
    {
      name: "Chick-Mush Spaghetti Pasta",
      price: 15.0,
      desc: "Spaghetti tossed in our special secret pasta sauce with grilled chicken and fresh mushrooms.",
      comesWith: "Comes with Complimentary Garlic Bread!",
      img: dishChickMush,
    },
    {
      name: "Penne Beast Slayer",
      price: 16.0,
      comesWith: "Comes with Complimentary Garlic Bread!",
      img: dishPenne,
    },
  ],
  appetizers: [
    {
      name: "Nacho Blast",
      price: 17.0,
      desc: "Loaded nachos with seasoned beef, fresh veggies, cheese and more!",
      comesWith: "Comes with Complimentary Salsa!",
      addons: [{ id: "sour-cream", label: "Sour Cream", price: 1.99 }],
      img: dishNacho,
    },
    {
      name: "Bomber's Chili Poutine",
      price: 10.0,
      deal: true,
      img: dishBombers,
    },
    {
      name: "Hotty Fingers and Fries",
      price: 10.0,
      deal: true,
      img: dishHotty,
    },
    { name: "Chicksar Salad", price: 10.0, deal: true },
  ],
  dippings: [
    { name: "Pattista sauce", price: 2.99, unit: "2 oz" },
    { name: "Burger Sauce", price: 2.99, unit: "2 oz" },
    { name: "Hot Sauce", price: 1.99, unit: "2 oz" },
    { name: "Honey Garlic", price: 1.99, unit: "2 oz" },
    { name: "BBQ Sauce", price: 1.99, unit: "2 oz" },
    { name: "Honey Dill", price: 1.99, unit: "2 oz" },
  ],
  drinks: [
    { name: "Water", price: 1.99, unit: "Can" },
    { name: "Coke regular", price: 1.99, unit: "Can" },
    { name: "Coke Zero", price: 1.99, unit: "Can" },
    { name: "Diet Coke", price: 1.99, unit: "Can" },
    { name: "Pepsi", price: 1.99, unit: "Can" },
    { name: "Diet Pepsi", price: 1.99, unit: "Can" },
    { name: "Canada Dry", price: 1.99, unit: "Can" },
    { name: "Dr. Pepper", price: 1.99, unit: "Can" },
    { name: "A&W Root Beer", price: 1.99, unit: "Can" },
    { name: "Fanta (Orange)", price: 1.99, unit: "Can" },
    { name: "Fanta (Pineapple)", price: 1.99, unit: "Can" },
    { name: "7 Up", price: 1.99, unit: "Can" },
    { name: "Brisk Iced Tea", price: 1.99, unit: "Can" },
  ],
  deals10: [
    "Bomber's Chili Poutine",
    "Hotty Fingers and Fries",
    "Chicksar Salad",
    "Sweet Bomb Solo Bite Burger",
    "The Uno Fatty Burger",
  ],
};

export const HERO_IMAGES = {
  burger: {
    img: dishBbq,
    alt: "BBQ Beef Lover burger with complimentary fries — Pattista promotional poster",
  },
  pasta: {
    img: dishPenne,
    alt: "Penne Beast Slayer — creamy penne with seasoned beef and complimentary garlic bread",
  },
};

export const FEATURED = [
  { name: "The Del Mar Spaghetti", price: "$17.00", img: dishDelMar },
  { name: "The SweetBomb", price: "$14.00", img: dishSweetbomb },
  { name: "Nacho Blust", price: "$17.00", img: dishNacho },
  { name: "BBQ Beef Lover", price: "$17.00", img: dishBbq },
  { name: "The Chick-slaw Burger", price: "$13.00", img: dishChickslaw },
  { name: "The Chick-Mush Spaghetti", price: "$15.00", img: dishChickMush },
  { name: "Penne Beast Slayer", price: "$16.00", img: dishPenne },
  { name: "Hotty Fingers & Fries", price: "$10.00", img: dishHotty },
  { name: "Bomber's Chili Poutine", price: "$10.00", img: dishBombers },
];

export const EXTRAS_IMAGES = {
  dippings: {
    img: dipsSpread,
    alt: "Six Pattista dipping sauces in a row — ripe mango Pattista sauce, pinkish-orange burger sauce, hot sauce, honey garlic, BBQ sauce and honey dill",
  },
  drinks: {
    img: drinksSpread,
    alt: "A lineup of cold fountain drinks with ice and straws on a warm amber background",
  },
};

export const SOCIALS = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/share/1MAouxNWpH/",
    icon: "facebook",
    testid: "social-facebook-link",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/pattista_winnipeg",
    icon: "instagram",
    testid: "social-instagram-link",
  },
];

export const TAX_SETTINGS = {
  configured: true,
  label: "GST + PST",
  gstPercent: 5,
  pstPercent: 7,
  ratePercent: 12,
  note: "Menu prices exclude tax. GST (5%) and PST (7%) — 12% combined — are added to the estimate.",
};

export const DELIVERY_LINKS = [
  {
    name: "UberEATS",
    url: "https://www.ubereats.com/ca/store/pattista/AtaTGz0dSCWxcYMRnNRTNA",
    testid: "delivery-partner-ubereats",
  },
  {
    name: "DoorDash",
    url: "https://www.doordash.com/en-CA/store/pattista-winnipeg-52312465/121460760/",
    testid: "delivery-partner-doordash",
  },
];

export const slug = (s) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const fmt = (n) => `$${n.toFixed(2)}`;
